/**
 * The one place in apps/web that reads `import.meta.env` (§7).
 * Everything else imports `config`.
 */
const required = (name: string, value: unknown): string => {
  if (typeof value !== 'string' || value.length === 0) {
    throw new Error(`Missing ${name}. Copy apps/web/.env.example to .env and fill it in.`)
  }
  return value
}

const raw = import.meta.env

export const config = {
  apiUrl: required('VITE_API_URL', raw.VITE_API_URL),
  supabaseUrl: required('VITE_SUPABASE_URL', raw.VITE_SUPABASE_URL),
  supabaseAnonKey: required('VITE_SUPABASE_ANON_KEY', raw.VITE_SUPABASE_ANON_KEY),
  isProduction: raw.PROD,
} as const

export type WebConfig = typeof config
